export const LOCATION_CREATE = "LOCATION_CREATE";
